angular.module('unica_workshop.workshop_controllers')

.controller('WorkshopListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	WorkshopListService, WorkshopDeleteService
) {
	$scope.workshopList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadWorkshopLists = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		WorkshopListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {

					$scope.workshopList = $scope.workshopList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadWorkshopLists();

	$scope.deleteWorkshop = function(workshopId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare questo workshop?',
			text: 'Confermi la cancellazione del workshop?'
		}).then(function() {

			$scope.showLoader();
			WorkshopDeleteService
				.delete( workshopId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.workshopList, function(workshop, key) {
							if ( workshop.id == workshopId ) {
								$scope.workshopList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Workshop eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};


	$scope.prepareExportUrl = function()
	{
		$scope.showLoader();
		WorkshopListService
			.exportAll( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportWorkshop = true;
					$scope.exportWorkshopUrl      = url;
				}
			});
	};

})

;